export default "__VITE_ASSET__BFsiZpQe__"